// Google Analytics 4 (gtag.js) helpers.
//
// The gtag.js library and base config are loaded in public/index.html. These
// helpers wrap window.gtag so the rest of the app can log analytics events and
// page views without touching the global directly. All calls fail safe if
// gtag has not loaded (ad blockers, offline, dev without network).

export const GA_MEASUREMENT_ID = "G-9EQ3CT9LXZ";

type GtagParams = Record<string, unknown>;

const isReady = (): boolean =>
  typeof window !== "undefined" && typeof window.gtag === "function";

/**
 * Send a page_view. Called automatically on route changes via
 * hooks/usePageTracking; rarely needs to be called by hand.
 */
export const trackPageView = (path: string, title?: string): void => {
  if (!isReady()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
  });
};

/**
 * Log a custom analytics event.
 *
 * @example
 *   trackEvent("update_sent", { recipient_count: 12, plan: "pro" });
 *   trackEvent("integration_connected", { provider: "stripe" });
 */
export const trackEvent = (action: string, params: GtagParams = {}): void => {
  if (!isReady()) return;
  window.gtag("event", action, params);
};
